<div class="d-flex flex-row text-center w-100 align-items-center">
<h1>En maintenance !</h1>
</div>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/account/dashboard/components/dashboard/dashboard.component.html